import React from "react";
import Newsletter from "./Newsletter";

const NewsletterWidget = ({ value, role }) => {
   return (
      <Newsletter
         role={role}
         widgetName={value.name}
         widgetId={value.id}
         newsletterId={value.newsletterId}
         xs={value.xsWidth}
         sm={value.smWidth}
         md={value.mdWidth}
         lg={value.lgWidth}
         xl={value.xlWidth}
         priority={value.priority}
         backgroundColourHex={value.backgroundColourHex}
      />
   );
};

export default NewsletterWidget;
